import { buildUseSetRecoilState } from "../../common/miscellaneous/buildUseSetRecoilState";
import { countryAdministrativeAreasAtom } from "../miscellaneous/countryAdministrativeAreasAtom";

export const useSetCountryAdministrativeAreasState = buildUseSetRecoilState(
  countryAdministrativeAreasAtom
);
